import { render, staticRenderFns } from "./OTA.vue?vue&type=template&id=58fe4380"
import script from "./OTA.vue?vue&type=script&lang=js"
export * from "./OTA.vue?vue&type=script&lang=js"
import style0 from "./OTA.vue?vue&type=style&index=0&id=58fe4380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports